import React from 'react'
import ReactDOM from 'react-dom'

import App from './components/app/App'

// import './main.scss'

const rootElement = document.getElementById('root')
ReactDOM.render(<App />, rootElement)
